import React from 'react';

export const IconSmallSearchLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M15.5 10.5a5 5 0 11-10 0 5 5 0 0110 0zm-1.588 5.534a6.5 6.5 0 112.121-2.121l3.33 3.33a1 1 0 010 1.414l-.706.707a1 1 0 01-1.414 0l-3.33-3.33z"
            fill="#616161"
            fillRule="evenodd"
        />
    </svg>
);
